import StoryCta from "./StoryCta";
import { Reveal } from "@/components/cinema/Reveal";

const ASSET = process.env.PUBLIC_URL || "";

export default function StoryTimeline({ stages }) {
  return (
    <section className="relative bg-[hsl(var(--gaza-teal-deep))] text-white" data-testid="restoration-story" data-variant="timeline">
      <div className="container-gaza pt-20 pb-10">
        <div className="live-pill mb-5"><span className="dot"></span> The restoration journey</div>
        <h2 className="display-chunky text-4xl md:text-6xl leading-[0.92]">
          From flood to <span className="text-[hsl(var(--gaza-blue-bright))]">back home.</span>
        </h2>
        <p className="mt-6 text-white/70 text-base md:text-lg max-w-xl leading-relaxed">
          One house, five stages. This is what happens between the moment you call and the moment you walk back in.
        </p>
      </div>

      <ol>
        {stages.map((st, i) => (
          <li key={st.key} className="story-step" data-testid={`story-step-${i + 1}`}>
            <img
              src={`${ASSET}${st.img}`}
              alt={`Stage ${st.n}: ${st.title}`}
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="story-gradient" aria-hidden />
            <div className="grain absolute inset-0" aria-hidden />
            <div className="relative container-gaza pb-14 pt-40 w-full">
              <Reveal>
                <div className="flex items-center gap-3 mb-4">
                  <span className={`w-2 h-2 rounded-full ${i === 0 ? "bg-[hsl(var(--bh-red-bright))]" : "bg-[hsl(var(--gaza-blue-bright))]"}`} />
                  <span className="text-[11px] uppercase tracking-[0.3em] font-extrabold text-white/70">Stage {st.n} <span className="text-white/35">/ {String(stages.length).padStart(2, "0")}</span></span>
                </div>
                <h3 className="display-chunky text-4xl md:text-6xl leading-[0.92]">{st.title}</h3>
                <p className="mt-5 text-white/80 leading-relaxed max-w-xl">{st.desc}</p>
                <div className="mt-6 flex items-baseline gap-3">
                  <span className="display-chunky text-2xl text-[hsl(var(--gaza-blue-bright))] whitespace-nowrap">{st.stat}</span>
                  <span className="text-[11px] uppercase tracking-[0.22em] text-white/55 font-extrabold">{st.statLabel}</span>
                </div>
              </Reveal>
            </div>
          </li>
        ))}
      </ol>

      <div className="container-gaza py-16">
        <Reveal><StoryCta /></Reveal>
      </div>
    </section>
  );
}
